import React from "react";
import { RequestTypeSelector } from '@rankmi/workflows-app';
import { ATSWrapper } from "@rankmi/ats-app"
import { Provider } from "react-redux";
import AppStore from "../../requests/redux/store";
import { EnterpriseService } from "@frontend/src/core/services/enterprise_service";
import { OrganizationService } from "@frontend/src/core/services/organization_sevice";
import { useState } from "react";
import { DEFAULT_REQUISITION_ACTIVE_MODULES } from "@frontend/src/core/workflows/hiring_workflow_app_modules";

const RequestTypeDefault = ({
  enterprise,
  organization
}) => {
  const enterpriseService = new EnterpriseService();
  const organizationService = new OrganizationService();
  const [requestTypeId, setRequestTypeId] = useState(organization.request_type_id)
  const [loading, setLoading] = useState(false);

  const handleResponse = (response) => {
    if (!loading && response?.id !== requestTypeId) {
      setLoading(true);
      setRequestTypeId(response.id);
      
      // Convertir respuesta singular a formato JSONB (array de objetos)
      const requestTypes = response.id && response.name 
        ? [{ id: response.id, name: response.name }]
        : [];
      
      organizationService.updateRequestType({
        request_types: requestTypes
      })
      setLoading(false);
    }
  }



  return (
    <React.Fragment>
      <div className="card settings-card">
        <div className="card-header">
          <div className="title">Formulario de Alta por defecto</div>
        </div>
        <div className="card-body">
          <div>
            <ATSWrapper>
              <Provider store={AppStore}>
                <RequestTypeSelector
                  allowFetchAll
                  activeModules={DEFAULT_REQUISITION_ACTIVE_MODULES}
                  id={requestTypeId}
                  onChange={handleResponse}
                />
              </Provider>
            </ATSWrapper>
          </div>
          <button className="btn btn-sairys mt-15" onClick={()=> {
              handleResponse({id: null, name: null})
              location.reload();
            }  
          }>
            Limpiar selección
          </button>
        </div>
      </div>
    </React.Fragment>
  )
}

export default RequestTypeDefault;